export default __webpack_public_path__ + "1a77adcbc877a8286ed843fa7318a714.svg";